
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ColumnsMeta"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchType"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"context"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AttributesContext"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"objectType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attrs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"context"},"value":{"kind":"Variable","name":{"kind":"Name","value":"context"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attrName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isMapping"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isCustomAttribute"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customAttributeType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sorListing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sorListingPermanent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sorEditing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sorBulkEditing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sortable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mandatory"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":1009}};
    doc.loc.source = {"body":"# Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved\n# Unauthorized use, copying, distribution, displaying, or public performance of\n# this file, via any medium, is strictly prohibited. All information contained\n# herein is proprietary and confidential and may not be shared with any third\n# party without the express written consent of Reciprocity, Inc.\n\n# TODO: consolidate with '@/graphql/listing/filters/Attributes.gql' after adding support for CAs\nquery ColumnsMeta($type: SearchType!, $context: AttributesContext!) {\n  objectType(name: $type) {\n    # TODO: Manually remove CAs\n    # TODO: Manually split regular attrs and mapped attrs\n    attrs(context: $context) {\n      name\n      displayName # TODO: this is currently \"map:attr\", should have \"map\" part removed and have name in uppercase\n      attrName\n      isMapping\n      isCustomAttribute\n      customAttributeType\n      sorListing\n      sorListingPermanent\n      sorEditing\n      sorBulkEditing\n      sortable\n      mandatory\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["ColumnsMeta"] = oneQuery(doc, "ColumnsMeta");
        
